import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { isFlashAdmin } from '../../utils/adminAccess';

type RoleGuardProps = {
  children: React.ReactNode;
  allowedRoles: string[];
  redirectTo?: string;
  /** When set, allows is_superuser / ADMIN / SUPER_ADMIN (Flash admin console). */
  requireFlashAdmin?: boolean;
};

const RoleGuard: React.FC<RoleGuardProps> = ({
  children,
  allowedRoles,
  redirectTo = '/',
  requireFlashAdmin = false,
}) => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex justify-center items-center min-h-[40vh]">
        <div className="w-12 h-12 rounded-full border-b-2 border-blue-600 animate-spin" />
      </div>
    );
  }

  if (requireFlashAdmin && isFlashAdmin(user)) {
    return <>{children}</>;
  }

  if (!user?.role || !allowedRoles.includes(user.role)) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export default RoleGuard;
